import { FixedComment } from "webportalclient";
import { v4 } from "uuid";

export const Ats2019SessionDefaults: FixedComment[] = [
    {
        id: v4(),
        comment: "Acceptability and/or repeatability criteria not met despite patient’s best efforts.",
        description: "Acceptability and/or repeatability criteria not met despite patient’s best efforts.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 0
    },
    {
        id: v4(),
        comment: "Spirometry induced bronchospasm.",
        description: "Spirometry induced bronchospasm.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 1
    },
    {
        id: v4(),
        comment: "Patient was too tired to continue.",
        description: "Patient was too tired to continue.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 2
    },
    {
        id: v4(),
        comment: "FEV1 dropped more than 20% from baseline.",
        description: "FEV1 dropped more than 20% from baseline.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 3
    },
    {
        id: v4(),
        comment: "Motivation difficulties.",
        description: "Motivation difficulties.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 4
    },
    {
        id: v4(),
        comment: "Coordination difficulties.",
        description: "Coordination difficulties.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 5
    },
]

export const Ats2019TestDefaults: FixedComment[] = [
    {
        id: v4(),
        comment: "Cough during the first second of expiration.",
        description: "Cough during the first second of expiration.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 0
    },
    {
        id: v4(),
        comment: "Glottis closure.",
        description: "Glottis closure.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 1
    },
    {
        id: v4(),
        comment: "Early termination.",
        description: "Early termination.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 2
    },
    {
        id: v4(),
        comment: "Hesitant start of test.",
        description: "Hesitant start of test.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 3
    },
    {
        id: v4(),
        comment: "Obstructed mouthpiece or breathing tube.",
        description: "Obstructed mouthpiece or breathing tube.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 4
    },
    {
        id: v4(),
        comment: "Leak around mouthpiece.",
        description: "Leak around mouthpiece.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 5
    },
    {
        id: v4(),
        comment: "Not at TLC prior to expiration.",
        description: "Not at TLC prior to expiration.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 6
    },
    {
        id: v4(),
        comment: "Operator changed maneuver designation from acceptable to unacceptable.",
        description: "Operator changed maneuver designation from acceptable to unacceptable.",
        followOnCommentAvailable: false,
        followOnCommentRequired: false,
        displayOrder: 7
    },
    {
        id: v4(),
        comment: "Other",
        description: "Other",
        followOnCommentAvailable: true,
        followOnCommentRequired: true,
        followOnCommentAnnotation: "Please enter a reason",
        displayOrder: 8
    },
]
